import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as shopActions from '../actions/shop.action';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getCustomerAccessToken } from '../selectors';
import { ShopService } from '../../services';
import { getActiveLanguageNoCulture } from '@teamfoster/sdk/language-ngrx';

@Injectable()
export class ShopEffects {
  constructor(private actions$: Actions, private shopService: ShopService, private store: Store) {}

  GetShopData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(shopActions.LoadShopData),
      withLatestFrom(this.store.select(getCustomerAccessToken), this.store.select(getActiveLanguageNoCulture)),
      switchMap(([{}, token, lang]) =>
        this.shopService.GetShopData(lang).pipe(
          map(data => shopActions.LoadShopDataSuccess({ data })),
          catchError(errors => of(shopActions.LoadShopDataFail({ errors })))
        )
      )
    );
  });
}
